import React from "react";
import SidenavbarTemp from "../sidenavbar/SidenavbarTemp";
import "./FilterRightDrawer.css";

const FilterRightDrawer = ({
  isOpen,
  onClose,
  selectedColumns,
  toggleColumnSelection,
  mode,
  setMode,
  updatedAuditRows,
  handleRefreshClick,
  setAuditDetails,
  setIsRowsLoading,
  isRowsLoading,
  getAuditRowsByFilter,
  appliedFilters,
  setAppliedFilters,
  setHasMore,
  setPage,
  auditDetails,
  setAuditRows,
  setflagAuditRows,
  flagauditRows,
  editFlageData,
  getAuditRowsData,
  selectedEpisodeRows,
  setSelectedEpisodeRows,
  isAllEpisodesSelected,
  setIsAllEpisodesSelected,
  recall_page,
  setRecall_page,
  isAssigned,
  setIsAssigned,
  unassined_page,
  setUnassined_page,
  addUnassignReason,
  setAddUnassignReason,
  searchEpisodeIdentifier,
  setSearchEpisodeIdentifier,
  recommendations,
  setRecommendations,
  selectAllFiles,
  setSelectAllFiles,
}) => {
  // console.log("RightDrawer rendering, isOpen:", isOpen); // Debug log
  return (
    <>
      {isOpen && (
        <>
          <div className="sidebar-overlay" onClick={onClose}></div>
          <div className={`sidebar-drawer ${isOpen ? "open" : ""}`}>
            <SidenavbarTemp
              selectedColumns={selectedColumns}
              toggleColumnSelection={toggleColumnSelection}
              mode={mode}
              setMode={setMode}
              updatedAuditRows={updatedAuditRows}
              handleRefreshClick={handleRefreshClick}
              setAuditDetails={setAuditDetails}
              setIsRowsLoading={setIsRowsLoading}
              isRowsLoading={isRowsLoading}
              getAuditRowsByFilter={getAuditRowsByFilter}
              appliedFilters={appliedFilters}
              setAppliedFilters={setAppliedFilters}
              setHasMore={setHasMore}
              setPage={setPage}
              auditDetails={auditDetails}
              setAuditRows={setAuditRows}
              setflagAuditRows={setflagAuditRows}
              flagauditRows={flagauditRows}
              editFlageData={editFlageData}
              getAuditRowsData={getAuditRowsData}
              selectedEpisodeRows={selectedEpisodeRows}
              setSelectedEpisodeRows={setSelectedEpisodeRows}
              isAllEpisodesSelected={isAllEpisodesSelected}
              setIsAllEpisodesSelected={setIsAllEpisodesSelected}
              recall_page={recall_page}
              setRecall_page={setRecall_page}
              isAssigned={isAssigned}
              setIsAssigned={setIsAssigned}
              unassined_page={unassined_page}
              setUnassined_page={setUnassined_page}
              addUnassignReason={addUnassignReason}
              setAddUnassignReason={setAddUnassignReason}
              searchEpisodeIdentifier={searchEpisodeIdentifier}
              setSearchEpisodeIdentifier={setSearchEpisodeIdentifier}
              recommendations={recommendations}
              setRecommendations={setRecommendations}
              selectAllFiles={selectAllFiles}
              setSelectAllFiles={setSelectAllFiles}
            />
          </div>
        </>
      )}
    </>
  );
};

export default FilterRightDrawer;